import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=c357d82c&scoped=true&"
import script from "./Relay.vue?vue&type=script&lang=ts&"
export * from "./Relay.vue?vue&type=script&lang=ts&"
import style0 from "./Relay.vue?vue&type=style&index=0&id=c357d82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c357d82c",
  null
  
)

export default component.exports